module.exports = __webpack_public_path__ + "img/cs-basicEduS-3.a9d34c6e.jpg";